import { render, staticRenderFns } from "./SupportBase.vue?vue&type=template&id=b2969c8c"
import script from "./SupportBase.vue?vue&type=script&lang=js"
export * from "./SupportBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports